// extracted by mini-css-extract-plugin
export var activityContainer = "_jc-0";
export var typingIndicatorContainer = "_jc-1";
export var typingIndicatorDot = "_jc-2";
export var wave = "_jc-3";